import { combineReducers } from 'redux'
import * as actions from '../actions'
import booleanReducer from '../utils/booleanReducer'

export const initialState = {
  isFetching: false,
  isPutting: false,
  items: [],
  putError: null,
}

const isFetching = booleanReducer({
  defaultState: initialState.isFetching,
  trueTypes: [actions.GET_VERTICALS_REQUEST],
  falseTypes: [actions.GET_VERTICALS_SUCCESS, actions.GET_VERTICALS_FAILURE],
})

const isPutting = booleanReducer({
  defaultState: initialState.isPutting,
  trueTypes: [actions.PUT_VERTICAL_REQUEST],
  falseTypes: [actions.PUT_VERTICAL_SUCCESS, actions.PUT_VERTICAL_FAILURE],
})

const items = (state = initialState.items, { type, payload }) => {
  if (type === actions.GET_VERTICALS_SUCCESS) {
    return [...payload]
  }
  return state
}

const putError = (state = initialState.putError, { type, payload }) => {
  if (type === actions.PUT_VERTICAL_FAILURE) {
    return payload
  }
  if (
    type === actions.PUT_VERTICAL_REQUEST ||
    type === actions.PUT_VERTICAL_SUCCESS
  ) {
    return null
  }

  return state
}

export default combineReducers({
  isFetching,
  isPutting,
  items,
  putError,
})



// WEBPACK FOOTER //
// ./src/reducers/verticals.js